import { helper } from '@ember/component/helper';
import { isEmpty } from '@ember/utils';
import GoalState from '@linc-technologies/linced-common/enums/goal-state';

/**
 * stateClass returns a BEM class based on the awarded state.
 *
 * @param {State} state - The state model.
 * @param classElement - The Block Element string to append the Modifier to.
 * @returns {string}
 */
export function stateClass([state, classElement]) {
  let elem = classElement ? classElement : '';
  if (isEmpty(state)) {
    return `${elem}--not-set`;
  }

  switch (state.awarded) {
    case GoalState.SECURE:
      return `${elem}--secure`;

    case GoalState.DEVELOPING:
      return `${elem}--developing`;

    default:
      return `${elem}--not-set`;
  }
}

export default helper(stateClass);
